<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :auto-select-first-row="false"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @refresh="onRefresh"
        @selectionChanged="rowSelectionChanged"
      />
    </div>
    <div class="button-containers mb-0">
      <!-- <button class="btn primary small" @click="openDialog">Thêm</button> -->
      <button
        class="btn primary small"
        :disabled="selectedRows.length == 0"
        @click="editMaterialQuantification"
      >
        {{ $t('button.modify') }}
      </button>
      <!-- <button class="btn primary small" @click="getTemplateFile">
        {{ $t('button.downloadTemplate') }}
      </button> -->
      <button
        class="btn primary small"
        :disabled="selectedRows.length == 0"
        @click="dialogFormVisible1 = true"
      >
        {{ $t('button.uploadFromExcel') }}
      </button>
    </div>
    <el-dialog
      :title="$t('dialog.titleMaterialQuantificationUpdate')"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <!-- <button class="btn primary small" @click="addRows1">Thêm</button> -->
      <div class="grid-scroll mt-10" style="height: 200px">
        <GridVx
          ref="modifyQuantityDialog"
          :columns="modifyQtyCols"
          :auto-size-cell="true"
          :context="context"
          :rows="rows1"
          dom-layout="scroll"
          class="agGrid"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            Huỷ
          </button>
          <button
            v-if="isEdit"
            class="btn primary small"
            @click="updateMaterialQuantification"
          >
            Cập nhật
          </button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogFormVisible1"
      title="Nhập từ Excel"
      width="1000px"
      :close-on-click-modal="false"
    >
      <div class="das-info-title mt-0 mb-10">Danh sách lỗi</div>
      <div style="height: 300px">
        <GridVx
          ref="agGrid"
          dom-layout="scroll"
          :columns="columns2"
          :rows="errorExcelUploadRows"
          class="agGrid"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible1 = false"
          >
            Đóng
          </button>
          <button class="btn primary small" @click="getTemplateFile">
            Tải mẫu
          </button>
          <!-- <button class="btn primary small outline" @click="getTemplateFile1">
            Tải mẫu
          </button> -->
          <FileInput
            ref="uploadFile"
            title="Chọn tệp tin"
            @onSelectFile="onSelectUploadList"
          />
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import FileInput from '@/components/ui/FileInput.vue'
import { downloadFile } from '@/utils/file-handler'
import {
  CellRenderTextInput,
  CellRenderSelect,
  CellHeaderAddIcon,
  CellRenderDeleteIcon
} from '@/utils/cellRenders.js'
import {
  addMaterialQuantificationExcelApi,
  getMaterialQuantificationTemplateApi,
  getListMaterialQuantificationApi,
  addMaterialQuantificationApi,
  updateMaterialQuantificationApi,
  deleteMaterialQuantificationApi,
  getAllMaterial
} from '@/api/configuration/accounting/product/materialQuantification.js'
import { getServiceTypeListApi } from '@/api/common/code'
import { Message } from 'element-ui'
export default {
  components: {
    CellRenderTextInput,
    CellRenderSelect,
    FileInput,
    CellHeaderAddIcon,
    CellRenderDeleteIcon
  },
  data() {
    return {
      selectedRows: [],
      dialogFormVisible1: false,
      serviceTypeOptions: [],
      quantityDeclarationOptions: [],
      loading: false,
      columns: [
        {
          headerName: 'Mã',
          field: 'code',
          tooltipField: 'code',
          maxWidth: 200
        },
        {
          headerName: 'Tên sản phẩm',
          field: 'name',
          tooltipField: 'name',
          maxWidth: 200
        },
        {
          headerName: 'Đơn vị',
          field: 'unit',
          tooltipField: 'unit',
          maxWidth: 200
        },
        {
          headerName: 'Khai báo định lượng',
          wrapText: true,
          autoHeight: true,
          field: 'materials',
          tooltipField: 'materials',
          valueGetter: params => {
            let string = ''
            if (params.data.materials) {
              params.data.materials.forEach(item => {
                string += `${item.name}: ${item.quantity} ${item.unit}; `
              })
            }
            return string
          }
        }
      ],
      modifyQtyCols: [
        {
          headerName: 'Giá trị lựa chọn',
          field: 'material_id',
          cellRenderer: 'CellRenderSelect',
          cellRendererParams: () => {
            return {
              options: this.quantityDeclarationOptions.map(item => {
                return {
                  label: item.material_name,
                  value: item.material_id
                }
              }),
              refName: 'material_id'
            }
          }
        },
        {
          headerName: 'Số lượng',
          field: 'quantity',
          cellRenderer: 'CellRenderTextInput',
          cellRendererParams: () => {
            return {
              type: 'number',
              colName: 'quantity'
            }
          }
        },
        {
          headerName: '',
          width: 50,
          cellRenderer: 'CellRenderDeleteIcon',
          headerComponent: 'CellHeaderAddIcon',
          cellStyle: () => {
            return {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          },
          cellRendererParams: () => {
            return {
              agGrid: 'modifyQuantityDialog'
            }
          }
        }
      ],
      columns2: [
        {
          headerName: 'Mã sản phẩm',
          field: 'finished_product_code'
        },
        {
          headerName: 'Mã nguyên vật liệu',
          field: 'material_code'
        },
        {
          headerName: 'Đơn vị của nguyên vật liệu',
          field: 'material_cal_unit'
        },
        {
          headerName: 'Số lượng',
          field: 'quantity_string'
        },
        {
          headerName: 'Lỗi',
          minWidth: 500,
          field: 'errorDetail',
          tooltipField: 'errorDetail'
        }
      ],
      rows1: [],
      errorExcelUploadRows: [],
      rowId: null,
      rows: [],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {},
      attributeProdItem: {
        code: null,
        name: '',
        eng_name: '',
        attribute_category_id: 0
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  async mounted() {
    const res = await getServiceTypeListApi()
    const res1 = await getAllMaterial()
    this.serviceTypeOptions = res.data
    this.quantityDeclarationOptions = res1.data
    this.attachData()
  },
  methods: {
    rowSelectionChanged(row) {
      this.selectedRows = row
    },
    onAddRowInGrid() {
      this.addRows1()
    },
    onDeleteIconClicked(data) {
      const idx = data.rowIndex
      this.rows1.splice(idx, 1)
    },
    async onSelectUploadList(data) {
      const file = data[0]
      this.$refs.uploadFile.resetFile()
      const formData = new FormData()
      formData.append('excelFile', file)
      const array = []
      await addMaterialQuantificationExcelApi(formData)
        .then(res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.dialogFormVisible1 = false
          this.attachData()
        })
        .catch(error => {
          if (error.response?.data?.error_list) {
            error.response.data.error_list.forEach(item => {
              const errorList = item.list_error.map(item1 => {
                return `${this.$t(
                  `grid.column.${item1.column_name}`
                )} ${this.$t(`errorMsg.${item1.error_detail}`)}`
              })
              const errorJoined = errorList.join('\n')
              item.errorDetail = errorJoined
              // item.product_excel.errorDetail = errorJoined
              // item.product_excel.rowIndex = item.list_error[0].rowIndex
              array.push(item)
              this.errorExcelUploadRows = array
            })
          } else {
            const message = error.response?.data?.message || 'default'
            this.$message({
              type: 'error',
              message: this.$t(`errorMsg.${message}`)
            })
          }

          // this.$message({
          //   message: this.$t('errorMsg.uploadNotSuccess'),
          //   type: 'error'
          // })
          // const message = error.response?.data?.message || 'default'
          // this.$message({
          //   type: 'error',
          //   message: this.$t(`errorMsg.${message}`)
          // })
        })
    },
    async getTemplateFile() {
      await getMaterialQuantificationTemplateApi()
        .then(res => {
          downloadFile(res, 'Material_quatification_template.xlsx')
          // const message = res.message
          this.$message({
            type: 'success',
            message: 'Tải mẫu thành công'
            // message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    addRows1() {
      this.rows1.push({
        quantity: null,
        material_id: null
      })
    },
    textInputChange(params, data, colName) {
      const idx = params.rowIndex
      this.rows1[idx][colName] = data
    },
    SelectInputChange(colName, data, value) {
      g('colName', colName, value)
      const idx = data.rowIndex
      this.rows1[idx][colName] = value
    },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      this.attributeProdItem = {
        code: null,
        level: null,
        desc: null,
        order: null
      }
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    // CRUD
    async addMaterialQuantification() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      let data = await addMaterialQuantificationApi(this.attributeProdItem)
      this.dialogFormVisible = false
      await this.attachData()
      this.$message({
        type: 'success',
        message: 'Bạn đã thêm loại thuế thành công'
      })
    },
    editMaterialQuantification() {
      const row = this.selectedRows[0]
      this.rows1 = []
      if (row.materials) {
        row.materials.forEach(item => {
          this.rows1.push({
            material_id: item.id,
            quantity: item.quantity
          })
        })
      }
      this.isEdit = true
      this.dialogFormVisible = true
    },
    async deleteMaterialQuantification() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      if (!row) {
        this.$alert('Vui lòng chọn loại thuế', 'Error', {
          confirmButtonText: 'OK'
        })
        return false
      }
      const id = row.id
      const id_list = []
      id ? id_list.push(id) : null
      if (id_list.length == 0) {
        this.$alert('Bạn chưa chọn loại danh mục!', 'Error', {
          confirmButtonText: 'OK'
        })
      } else {
        this.$vxConfirm('Bạn chắc chắn muốn xoá danh mục này?', () => {
          deleteMaterialQuantificationApi({
            ids: id_list
          })
            .then(() => {
              this.$message({
                type: 'success',
                message: 'Bạn đã xoá loại danh mục thành công'
              })
              this.attachData()
            })
            .catch(() => {
              this.dialogFormVisible = false
            })
        })
      }
    },
    async updateMaterialQuantification() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()[0]
      let data = await addMaterialQuantificationApi(this.rows1, rowsSelected.id)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      this.loading = true
      let data = await getListMaterialQuantificationApi(this.searchParams)
      this.loading = false
      this.rows = data.data
      this.selectedRows = []
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
